import axios from "axios";
import "bulma/css/bulma.min.css";
import React from "react";
import liff from "@line/liff";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as actions from "./actions";
import AppConfig from "./AppConfig.json";
import RichMenuDesigner from "./RichMenuDesigner";
import { MD5 } from "crypto-js";

class RichMenuEditor extends React.Component {
  state = {
    description: {},
    selectedLayout: null,
    rich_menus: null,
    line_access_token: null,
    passwordAccepted: false,
  };

  constructor() {
    super();
    this.getRichmenus = this.getRichmenus.bind(this);
    this.saveRichmenu = this.saveRichmenu.bind(this);
  }

  componentDidMount() {
    if (MD5(window.prompt("????")).toString() === AppConfig.backend_passhash) {
      console.log("accepted");
      this.setState({ passwordAccepted: true });
    } else {
      console.log("un accepted");
      return;
    }
    this.initializeLiff(AppConfig.liff_id);
  }

  async initializeLiff(myLiffId) {
    try {
      await liff.init({
        liffId: myLiffId,
      });

      if (!liff.isLoggedIn()) {
        // console.log("Login")
        liff.login();
      } else {
        // let profile = await liff.getProfile()
        this.state.line_access_token = liff.getAccessToken();
        // console.log("Logined", this.state.line_access_token)
        this.getRichmenus();
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getRichmenus() {
    let config = {
      method: "GET",
      url: `${AppConfig.endpoint}/member/backend/rich_menus`,
      headers: {
        "x-access-token": this.state.line_access_token,
        "x-api-key": AppConfig.api_key,
      },
    };

    let result = await axios(config);
    result.data.forEach((element) => {
      element.description =
        element.description && JSON.parse(element.description);
      element.layout = element.layout && JSON.parse(element.layout);
    });

    this.setState({ rich_menus: result.data });
  }

  async saveRichmenu(name, description, layout, image_path) {
    console.log(name, description, layout, image_path);
    // Save rich menu
    let config = {
      method: "POST",
      url: `${AppConfig.endpoint}/member/backend/rich_menu`,
      headers: {
        "x-access-token": this.state.line_access_token,
        "x-api-key": AppConfig.api_key,
      },
      data: {
        type: name,
        description: JSON.stringify(description),
        layout: JSON.stringify(layout),
        image_path,
      },
    };

    await axios(config);
  }

  getRichmenu(type) {
    let { rich_menus } = this.state;
    let result = rich_menus.filter((i) => i.type === type);
    if (result.length > 0) {
      return result[0];
    }
    return null;
  }

  render() {
    let { passwordAccepted, rich_menus } = this.state;
    if (!passwordAccepted) return "";
    if (!this.state.line_access_token) return "";
    if (!rich_menus) return "Loading";

    return (
      <>
        <Header />

        <div className="container">
          <h3 className="title">Rich menu editor</h3>
          <div className="richmenu-designer">
            <h2 className="subtitle">Default</h2>
            <RichMenuDesigner
              name="default"
              onSave={this.saveRichmenu}
              data={this.getRichmenu("default")}
              line_access_token={this.state.line_access_token}
            />
          </div>

          <div className="richmenu-designer">
            <h2 className="subtitle">Member users</h2>
            <RichMenuDesigner
              name="member"
              onSave={this.saveRichmenu}
              data={this.getRichmenu("member")}
              line_access_token={this.state.line_access_token}
            />
          </div>

          <div className="richmenu-designer">
            <h2 className="subtitle">T1X Member</h2>
            <RichMenuDesigner
              name="t1x"
              onSave={this.saveRichmenu}
              data={this.getRichmenu("t1x")}
              line_access_token={this.state.line_access_token}
            />
          </div>
        </div>
      </>
    );
  }
}

function Header() {
  return (
    <nav className="navbar" role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        <a className="navbar-item" href="/">
          The 1 Admin
        </a>

        <button
          type="button"
          className="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>
      </div>
    </nav>
  );
}

export default withRouter(connect((state) => state, actions)(RichMenuEditor));
